import { Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import { makeStyles } from "@material-ui/core";
import { createUser, optimalPlan, postToHubSpot } from "../api/APIs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useCookies } from "react-cookie";
import AlertModal from "./AlertModal";
import CustomizedSnackbars from "./Alert";

let notAvailable = false;

const BillForm = ({
  userInfo,
  setNotAvailable,
  setShowloader,
  setAvailable,
  setOptimalPlan,
  optimalPlans,
  setShowForm,
  handleClick,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const [address, setAddress] = useState("");
  const [zipcode, setZipcode] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [esiid, setEsiid] = useState();
  const [puct, setPuct] = useState();
  const [meterId, setMeterid] = useState();
  const [providerName, setProvidername] = useState();
  const [totalAmountDue, setTotalAmountDue] = useState();
  const [invoiceNumber, setInvoiceNumber] = useState();
  const [dueDate, setDuedate] = useState();
  const [electricityUsage, setElectricityUsage] = useState();
  const [contractEndDate, setContractEndDate] = useState();
  const [energyCharge, setEnergyCharge] = useState();
  const [planType, setPlanType] = useState();
  const [planyTypeLabel, setPlanTypeLabel] = useState();
  const [showModal, setShowModal] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["ref_promo"]);
  const [email, setEmail] = useState();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [timer, setTimer] = useState(null);

  const min950 = useMediaQuery("(min-width:950px)");
  const min650 = useMediaQuery("(min-width:650px)");

  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    background: "#FFD27D",
    whiteSpace: "nowrap",
  }));

  const setForm = () => {

    let _energyCharge = userInfo?.bill_info?.electricity_charge_detail?.average_price;
    setAddress(userInfo?.service_address?.address);
    setZipcode(userInfo?.service_address?.zipcode);
    setCity(userInfo?.service_address?.city);
    setState(userInfo?.addrs[0]?.state);
    setEsiid(userInfo?.service_address?.esiid);
    setPuct(userInfo?.bill_info?.company_info?.puct);
    setMeterid(userInfo?.bill_info?.meter_id);
    setProvidername(userInfo?.bill_info?.company);
    setTotalAmountDue(
      userInfo?.bill_info?.electricity_charge_detail?.electric_amount
    );
    setInvoiceNumber(userInfo?.bill_info?.account_number);
    setDuedate(userInfo?.bill_info?.electricity_charge_detail?.due_date);
    setElectricityUsage(
      userInfo?.bill_info?.electricity_charge_detail?.electric_usage
    );
    setContractEndDate(
      userInfo?.bill_info?.customer_info?.contract_expiration_date
    );
    setEnergyCharge(
      (parseFloat(_energyCharge) * 100).toFixed(2)
    )
    setPlanType(userInfo?.bill_info?.customer_info?.plan_type)
  };

  const findOptimalPlan = async () => {
    let spliceAt = min950 ? 3 : min650 ? 2 : 1;
    let zip = "";
    if (userInfo?.service_address?.zipcode.includes("-")) {
      zip = userInfo?.service_address?.zipcode.split("-")[0];
    } else {
      zip = userInfo?.service_address?.zipcode;
    }
    const rate =
      (userInfo?.bill_info?.electricity_charge_detail?.electric_amount * 100) /
      userInfo?.bill_info?.electricity_charge_detail?.electric_usage;
    const response = await optimalPlan(
      zip,
      "SEOEIQ0002",
      1,
      rate,
      userInfo?.bill_info?.electricity_charge_detail?.electric_usage
    );

    let uniqueIds = [];
    let uniqueIdsArray = [];
    if (response === "ERROR" || response?.data?.Message) {
      setOptimalPlan([]);
      setShowForm(false);
      notAvailable = true;
      setShowloader(false);
      handleClick();
    } else {
      response?.data?.map((plan) => {
        if (plan.is_recommended) {
          notAvailable = false;
          uniqueIds = [...uniqueIds, plan];
        }
      });

      while (uniqueIds.length) {
        uniqueIdsArray = [...uniqueIdsArray, uniqueIds.splice(0, spliceAt)];
      }
      setOptimalPlan({
        plans: [...new Set(uniqueIdsArray)],
        zipCode: zip,
      });
      callOptimalPlans(zip);
    }
  };

  const callOptimalPlans = async (zip) => {
    const response = await createUser(
      userInfo?.ext?.meter_id,
      userInfo?.service_address?.address,
      zip,
      userInfo?.service_address?.street,
      userInfo?.service_address?.city,
      userInfo?.ext?.esiid,
      userInfo?.service_address?.esiid,
      userInfo?.ext?.company,
      userInfo?.ext?.puct
    );
    // }

    if (notAvailable) {
      setShowloader(false);
      setAvailable(false);
      setNotAvailable(true);
    } else {
      setShowloader(false);
      setNotAvailable(false);
      setAvailable(true);
      //navigate here
    }
  };

  const postUser = async () => {
    if (validateEmail(email)) {
      localStorage.setItem('BillEnergyCharge', energyCharge)
      setShowloader(true);
      findOptimalPlan();
    } else {
      setMessage("Please enter a valid email address!");
      setOpen(true);
    }

    // if (!Object.keys(userInfo).length === 0) {
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  useEffect(() => {
    if (userInfo.addrs) {
      setForm();
    }
  }, [userInfo]);

  useEffect(() => {
    if (!min950) {
      document.getElementById("form").scrollIntoView();
    }
  }, [min950]);

  useEffect(() => {
    if (planType) {
      setPlanTypeLabel(LearnMoreLable.find((item) => item.type === planType.split(' ').join('')))
    }

  }, [planType])

  useEffect(()=>{
    if (userInfo && email && validateEmail(email)) {
      if (timer) {
        clearTimeout(timer);
      }

      setTimer(setTimeout(() => {
        if (userInfo && email && validateEmail(email)) {
          handleSendForm();
        }
      }, 2000));
    }
  },[userInfo, email])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const handleSendForm = () =>{
    const names = userInfo?.bill_info?.customer_info?.customer_name?.trim().split(/\s+/);
    let firstName = "";
    let lastName = "";
    if (names && names.length > 0) {
      firstName=names[0]
    }

    if (names && names.length > 1) {
      lastName=names[names.length - 1]
    }
    localStorage.setItem("userInfo", JSON.stringify({firstName:firstName, lastName: lastName, email: email}))
    postToHubSpot(firstName, lastName, email, "No Comparison").then((res)=>{
      console.log(res);
    })
  }

  const handleEmailChange = (e)=>{
    setEmail(e.target.value);
    setOpen(false);
  }

  return (
    <Box
      mt={{ xs: "10%", lg: "0" }}
      width={{ xs: "100%", lg: "40%" }}
      sx={{
        display: "flex",
        flexDirection: "column",
        // justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // justifyContent: "space-between",
          marginBottom: "2%",
        }}
      >
        {planyTypeLabel && <Typography
          textTransform={"uppercase"}
          color={"#09507F"}
          fontWeight={500}
          marginBottom={'1rem'}
          fontSize={'1rem'}
        >
          <b>Alert:</b> {planyTypeLabel.label} <a style={{ color: "#00B49D", fontWeight: '800', textDecoration: "underline", cursor: 'pointer' }} onClick={() => { setShowModal(true) }}>Learn more.</a>
        </Typography>}
        <Box>
          <Typography
            id="form"
            fontSize="15px"
            color={theme.palette.secondary.main}
            fontWeight={400}
            variant="body2"
            mb="1%"
            whiteSpace="nowrap"
          >
            Bill Info
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              // justifyContent: "space-between",
            }}
          // mb="10%"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >

              <TextField
                id="outlined-basic"
                className={classes.root}
                value={`¢ ${energyCharge}` || ""}
                onChange={(e) => {
                  if (e.target.value.split(" ")[1]) {
                    setEnergyCharge(e.target.value.split(" ")[1]);
                  } else {
                    setEnergyCharge('')
                  }
                }}
                label="Energy Charge"
                variant="filled"
                sx={{
                  width: "49%",
                  marginBottom: "5px",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "16px",
                    borderRadius: "9vw",
                    padding: "1px 0 1px 10px",
                  },
                }}
              />

              <TextField
                id="outlined-basic"
                className={classes.root}
                value={`$ ${totalAmountDue}` || ""}
                onChange={(e) => {
                  if (e.target.value.split(" ")[1]) {
                    setTotalAmountDue(e.target.value.split(" ")[1]);
                  } else {
                    setTotalAmountDue('')
                  }
                }}
                label="Total Amount Due"
                variant="filled"
                sx={{
                  width: "49%",
                  marginBottom: "5px",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "16px",
                    borderRadius: "9vw",
                    padding: "1px 0 1px 10px",
                  },
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >

              <TextField
                id="outlined-basic"
                className={classes.root}
                value={invoiceNumber || ""}
                onChange={(e) => {
                  setInvoiceNumber(e.target.value);
                }}
                label="Account Number"
                variant="filled"
                sx={{
                  width: "49%",
                  marginBottom: "5px",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "16px",
                    borderRadius: "9vw",
                    padding: "1px 0 1px 10px",
                  },
                }}
              />
              <TextField
                id="outlined-basic"
                className={classes.root}
                value={dueDate || ""}
                onChange={(e) => {
                  setDuedate(e.target.value);
                }}
                label="Due Date"
                variant="filled"
                sx={{
                  width: "49%",
                  marginBottom: "5px",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "16px",
                    borderRadius: "9vw",
                    padding: "1px 0 1px 10px",
                  },
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}>
              <TextField
                id="outlined-basic"
                className={classes.root}
                value={`${electricityUsage} kWh` || ""}
                onChange={(e) => {
                  setElectricityUsage(e.target.value);
                }}
                label="Electricity Usage"
                variant="filled"
                sx={{
                  width: "49%",
                  marginBottom: "5px",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "16px",
                    borderRadius: "9vw",
                    padding: "1px 0 1px 10px",
                  },
                }}
              />

              <TextField
                id="outlined-basic"
                className={classes.root}
                value={contractEndDate || ""}
                onChange={(e) => {
                  setContractEndDate(e.target.value);
                }}
                label="Contract End Date"
                variant="filled"
                sx={{
                  width: "49%",
                  marginBottom: "5px",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "16px",
                    borderRadius: "9vw",
                    padding: "1px 0 1px 10px",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // justifyContent: "space-between",
          marginBottom: "2%",
        }}
      >
        <Box>
          <Typography
            fontSize="15px"
            color={theme.palette.secondary.main}
            fontWeight={400}
            variant="body2"
            mb="1%"
            whiteSpace="nowrap"
          >
            Personal Info
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              // justifyContent: "space-between",
            }}
          // mb="10%"
          >
            <Box>
              <TextField
                id="outlined-basic"
                className={classes.root}
                value={address || ""}
                onChange={(e) => {
                  setAddress(e.target.value);
                }}
                label="Address"
                variant="filled"
                sx={{
                  width: "100%",
                  marginBottom: "5px",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "16px",
                    borderRadius: "9vw",
                    padding: "1px 0 1px 10px",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "2%",
        }}
      >
        <Box>
          <Typography
            fontSize="15px"
            color={theme.palette.secondary.main}
            fontWeight={400}
            variant="body2"
            mb="1%"
            whiteSpace="nowrap"
          >
            Provider Info
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              // justifyContent: "space-between",
            }}
          // mb="10%"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <TextField
                id="outlined-basic"
                className={classes.root}
                value={providerName || ""}
                onChange={(e) => {
                  setProvidername(e.target.value);
                }}
                label="Provider Name"
                variant="filled"
                sx={{
                  width: "49%",
                  marginBottom: "5px",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "16px",
                    borderRadius: "9vw",
                    padding: "1px 0 1px 10px",
                  },
                }}
              />

              <TextField
                id="outlined-basic"
                className={classes.root}
                value={puct || ""}
                onChange={(e) => {
                  setPuct(e.target.value);
                }}
                label="PUCT"
                variant="filled"
                sx={{
                  width: "49%",
                  marginBottom: "5px",
                }}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    fontSize: "16px",
                    borderRadius: "9vw",
                    padding: "1px 0 1px 10px",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // justifyContent: "space-between",
          marginBottom: "2%",
        }}
      >
        <Box>
          <Typography
            fontSize="15px"
            color={theme.palette.secondary.main}
            fontWeight={400}
            variant="body2"
            mb="1%"
            whiteSpace="nowrap"
          >
            Compare Your Bill
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: "2%",
          }}
        >
          <TextField
            id="outlined-basic"
            className={classes.root}
            value={email}
            onChange={handleEmailChange}
            label="Enter email address to compare your bill*"
            variant="filled"
            sx={{
              width: { lg: "68%", sm: "100%" },
              marginBottom: "5px",
            }}
            InputProps={{
              disableUnderline: true,
              style: {
                fontSize: "16px",
                borderRadius: "9vw",
                padding: "1px 0 1px 10px",
              },
            }}
          />
          <Button
            onClick={postUser}
            className={classes.button}
            sx={{
              padding: "15px 0px",
              width: { lg: "30%", sm: "100%" },
            }}
            type="submit"
            disabled={!email}
          >
            <Typography
              fontSize={{
                xs: "10px",
                sm: "10px",
                md: "14px",
                lg: "15px",
              }}
              sx={{
                lineHeight: "21px",
                fontWeight: "1000",
                //fontStyle: "uppercase",
              }}
              color={!email ? "#fff" : "#09507F"}
            //width="1000px"
            >
              Compare your bill
            </Typography>
          </Button>
        </Box>
      </Box>

      <CustomizedSnackbars
        open={open}
        message={message}
        handleClose={handleClose}
      />

      <AlertModal open={showModal} handleClose={() => { setShowModal(false) }} content={planyTypeLabel?.content} />
    </Box>
  );
};

export default BillForm;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormLabel-root": {
      color: "#009A88", // or black
      top: "5px",
      left: "15px",
      fontSize: "100%",
    },
  },
  button: {
    transition: "all .1s ease-in-out",
    border: "3px solid #009A88",
    "&:hover": {
      background: "transparent",
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      color: "#009A88",
    },
    "&:disabled": {
      background: "#cccccc",
      color: "#fff"
    }
  },
  "@keyframes scale": {
    "0%": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
}));


const LearnMoreLable = [
  {
    type: 'FreeNights',
    label: "Youve uploaded a gimmicky free nights plan! ",
    content: "Did you know Texas electricity providers use free nights as a marketing gimmick? Free electricity at night is overcompensated by elevated daytime rates. Even with the free energy at night, your bills may end up much higher than you'd expect. If you're looking to save, we highly recommend enrolling in a simple fixed rate plan instead."
  },
  {
    type: "FreeWeekends",
    label: "You've uploaded a gimmicky free weekends plan! ",
    content: "Did you know Texas electricity providers use free weekends as a marketing gimmick? Free electricity on the weekend is overcompensated for by elevated weekday rates. Even with the free energy over the weekend, your bills may end up much higher than you'd expect. If you're looking to save, we highly recommend enrolling in a simple fixed rate plan instead."
  },
  {
    type: "BaseCharges",
    label: "You've uploaded a gimmick base charge plan! ",
    content: "Many Texas retail electricity providers add monthly base charges to every single bill. They claim that these fees help cover administrative and other operational costs. But if other providers can offer plans without base charges even with a more affordable energy charge, are these extra fees really necessary? If you're looking to save, we highly recommend enrolling in a simple fixed rate plan without a base charge instead."
  },
  {
    type: "UsageFees",
    label: "You've uploaded a gimmick usage fee plan! ",
    content: "Many Texas retail electricity providers charge usage fees when customers use the “too much” or “too little” electricity during a billing period. At BKV Energy, we don't believe there's a wrong amount of energy consumption. If you're looking to save, we recommend enrolling in a simple fixed rate plan without usage fees instead."
  },
  {
    type: "EVCharging",
    label: "You've uploaded a gimmicky EV charging plan! ",
    content: "Did you know Texas electricity providers use EV charging plans as a marketing gimmick? Free electricity at night for your electric vehicle is overcompensated for by elevated daytime rates. Even with the free energy at night, your bills may end up much higher than you'd expect. If you're looking to save, we highly recommend enrolling in a simple fixed rate plan instead."
  }
]